import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-mark-as-closedcommon-dialog',
  templateUrl: './mark-as-closedcommon-dialog.component.html',
  styleUrls: ['./mark-as-closedcommon-dialog.component.css'],
})
export class MarkAsClosedcommonDialogComponent implements OnInit {
  constructor(private dialog: MatDialog) {}
  ngOnInit(): void {}
  close() {
    this.dialog.closeAll();
  }
}
